import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDataSessions from '../dataHooks/useDataSessions';

export default () => {
  const navigate = useNavigate();
  const { pathname = '' } = useLocation();
  const { fetchSession } = useDataSessions();
  
  const pathParts = pathname.split('/')
  // Since pathname starts with '/' for example /home we want to always ignore the first empty string when doing a split
  pathParts.shift()

  const partDisplayMap = {
    'home': 'Home',
    'event': 'Event',
    'events': 'Events',
    'session': 'Session',
    'design': 'Design Center',
    'eventTemplate': 'Event Template',
    'sessionTemplate': 'Session Template'
  }

  const formatPart = (part) => {
    return partDisplayMap[part] !== undefined ? partDisplayMap[part] : part
  }

  /*
   * Having this very specific logic here in our common component is not ideal, but needed to get shit done.
   * Ideally this would be solved by having some sort of global state management system in place, but that adds
   * a lot of extra weight, and boiler plate code to what for now is a very small use case right here
   */
  const eventPartFn = async (partPath) => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('id');
    
    const session = await fetchSession(sessionId) || {}

    const { eventId } = session;
    if (eventId) {
      navigate(`${partPath}?id=${eventId}`);
    }
  }

  const partFnMap = {
    'event': eventPartFn
  }

  const onClickPart = (part) => {
    const partPath = (pathParts.slice(0,pathParts.indexOf(part) + 1)).join('/')
    if (partFnMap[part]) {
      partFnMap[part](partPath)
    } else {
      navigate(partPath);
    }
  }

  return pathParts.length > 1 && (
    <div style={{
      position: 'sticky',
      top: '0px',
      // top: '40px',
      zIndex: '998',
      display: 'flex',
      height: '39px',
      padding: '0px 20px',
      alignItems: 'center',
      background: '#ffffff',
      color: '#080808',
      borderBottom: '1px solid #C2C9D1',
    }}>
      {
        pathParts.map((part, index) => {
          const isLast = index === (pathParts.length - 1)
          const formattedPart = formatPart(part);
          return formattedPart && (
            <React.Fragment key={part}>
            <div 
              style={{
                color: isLast ? '#565656' : '#0280c6',
                textDecoration: isLast ? 'none' : 'underline',
                cursor: isLast ? 'default' : 'pointer',
              }}
              onClick={() => !isLast && onClickPart(part)}
            >
              {formattedPart}
            </div>
            {
              !isLast &&
              <div style={{
                margin: '0px 10px'
              }}>
                {'/'}
              </div>
            }
            </React.Fragment>
          )
        })
      }
    </div>
  )
}